import type { ReactNode } from 'react';

export const symbol_compress: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M195-410q-14 0-24.5-10.5T160-445q0-14 10.5-24.5T195-480h570q14 0 24.5 10.5T800-445q0 14-10.5 24.5T765-410H195Zm-5-121q-13 0-21.5-8.5T160-561q0-13 8.5-21.5T190-591h580q13 0 21.5 8.5T800-561q0 13-8.5 21.5T770-531H190ZM457.5-88.5Q449-97 449-110v-128l-56 55q-9 8-21 8.5t-21-8.5q-9-9-9-21t9-21l107-106q5-5 10-7t11-2q6 0 11 2t10 7l105 106q8 9 8.5 21t-8.5 21q-9 9-21 9t-21-9l-54-55v128q0 13-8.5 21.5T479-80q-13 0-21.5-8.5ZM468-662q-5-2-10-7L352-775q-8-8-8.5-20.5T352-817q9-9 21-9t21 9l54 55v-128q0-13 8.5-21.5T478-920q13 0 21.5 8.5T508-890v128l56-55q9-8 21-8.5t21 8.5q9 9 9 21t-9 21L500-669q-5 5-10 7t-11 2q-6 0-11-2Z"
		/>
	</svg>
);
